// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-search-profile__icon{
    margin-right: calc( var(--space-half) /2);
    border-radius: 50%;
    background-color: turquoise;
}

.league-search-profile__icon .icon-ball {
   color: var( --white-color );
   font-size: calc((var(--space)/4)*7);/*28px;*/
   border-radius: 50%;
   padding: calc(var(--space)/4);/*4px;*/
}
.league-search-profile__profile{
    width: 30%;
    font-size: calc( var(--space) - 2px );
}
.league-search-profile__username{

    width: 30%;
}

.league-search-profile__icon__icon__img{
    width: calc( (var(--space) /9)*20);
    height: calc( (var(--space) /9)*20);
    border-radius: 50%;
}

.league-search-profile__listitem .MuiTypography-body1 {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc( var(--space) - 2px );
    line-height: var(--space-and-half);
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--primary-dark-color) !important;
}

.league-search-profile__listitem .MuiTypography-body2 {
   font-size: calc( var(--space) - 5px );
   display: flex;
   align-items: center;
   letter-spacing: 0.0025em;
}

.league-search-profile__list{
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    border-radius: 0px 0px 14px 14px;
    padding-top: var(--space-half);
    position: fixed;
    background: white;
    max-width: 400px;
}

.league-search-profile {
   background: var(--white-color);
   overflow-y: auto !important;
   max-height: calc(var(--space-half) * 27);
}

.league-search-profile .MuiListItem-root.Mui-selected{
    background-color: var(--secondary-light-color) !important;
}

.league-search-profile .MuiListItem-button:hover{
    background-color: var(--hover-pb-bg-color);
}

.MuiListItemText-root.league-search-profile__listitem{
    margin-top: 0px !important;
    margin-bottom: 0px !important;
}

.MuiListItemIcon-root{
    min-width: 0px !important;
}

.league-search-profile .MuiList-padding{
    padding: 0px !important;
}

.league-search-profile .MuiListItem-gutters {
    padding-left: var(--space-half) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-search-member-list/LeagueSearchMemberListComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;GACG,2BAA2B;GAC3B,mCAAmC,CAAC,QAAQ;GAC5C,kBAAkB;GAClB,6BAA6B,CAAC,OAAO;AACxC;AACA;IACI,UAAU;IACV,qCAAqC;AACzC;AACA;;IAEI,UAAU;AACd;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,qCAAqC;IACrC,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,2CAA2C;AAC/C;;AAEA;GACG,qCAAqC;GACrC,aAAa;GACb,mBAAmB;GACnB,wBAAwB;AAC3B;;AAEA;IACI,iDAAiD;IACjD,gCAAgC;IAChC,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;GACG,8BAA8B;GAC9B,2BAA2B;GAC3B,wCAAwC;AAC3C;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C","sourcesContent":[".league-search-profile__icon{\n    margin-right: calc( var(--space-half) /2);\n    border-radius: 50%;\n    background-color: turquoise;\n}\n\n.league-search-profile__icon .icon-ball {\n   color: var( --white-color );\n   font-size: calc((var(--space)/4)*7);/*28px;*/\n   border-radius: 50%;\n   padding: calc(var(--space)/4);/*4px;*/\n}\n.league-search-profile__profile{\n    width: 30%;\n    font-size: calc( var(--space) - 2px );\n}\n.league-search-profile__username{\n\n    width: 30%;\n}\n\n.league-search-profile__icon__icon__img{\n    width: calc( (var(--space) /9)*20);\n    height: calc( (var(--space) /9)*20);\n    border-radius: 50%;\n}\n\n.league-search-profile__listitem .MuiTypography-body1 {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc( var(--space) - 2px );\n    line-height: var(--space-and-half);\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--primary-dark-color) !important;\n}\n\n.league-search-profile__listitem .MuiTypography-body2 {\n   font-size: calc( var(--space) - 5px );\n   display: flex;\n   align-items: center;\n   letter-spacing: 0.0025em;\n}\n\n.league-search-profile__list{\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    border-radius: 0px 0px 14px 14px;\n    padding-top: var(--space-half);\n    position: fixed;\n    background: white;\n    max-width: 400px;\n}\n\n.league-search-profile {\n   background: var(--white-color);\n   overflow-y: auto !important;\n   max-height: calc(var(--space-half) * 27);\n}\n\n.league-search-profile .MuiListItem-root.Mui-selected{\n    background-color: var(--secondary-light-color) !important;\n}\n\n.league-search-profile .MuiListItem-button:hover{\n    background-color: var(--hover-pb-bg-color);\n}\n\n.MuiListItemText-root.league-search-profile__listitem{\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n}\n\n.MuiListItemIcon-root{\n    min-width: 0px !important;\n}\n\n.league-search-profile .MuiList-padding{\n    padding: 0px !important;\n}\n\n.league-search-profile .MuiListItem-gutters {\n    padding-left: var(--space-half) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
